import React, { useState } from "react";
import Styles from "./Element.module.css";
import TextInput from "../../../../commons/Inputs/TextInput/TextInput";
import { useSelector } from "react-redux";
import SelectInput from "../../../../commons/Inputs/Select/SelectInput";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

const BankDetails = ({ userData, handleData, handleProceed }) => {
  const publicData = useSelector((state) => state?.publicSlice);

  // State Management
  const [formData, setFormData] = useState({
    bankName: userData.bankName || "",
    bankAddress: userData.bankAddress || "",
    accountNo: userData.accountNo || "",
    ifsc: userData.ifsc || "",
    rating: userData.rating || {},
    ratingYear: userData.ratingYear || "",
    agency: userData.agency || "",
    byRules: false,
    byLaw: false,
  });

  const [errors, setErrors] = useState({});

  // Handlers
  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    if (errors[field]) {
      setErrors((prevErrors) => {
        const { [field]: removedError, ...rest } = prevErrors;
        return rest;
      });
    }
  };

  const validateFields = () => {
    const requiredFields = [
      "bankName",
      "bankAddress",
      "accountNo",
      "ifsc",
      "rating",
      "ratingYear",
      "agency",
    ];
    const newErrors = {};

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = `${field
          .replace(/([A-Z])/g, " $1")
          .replace(/^./, (str) => str.toUpperCase())} is required`;
      }
    });
    if (!formData.rating?.id) {
      newErrors.rating = "Rating is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleContinue = (data) => {
    // if (!validateFields()) return;

    const bankRating = {
      bankAccounts: [
        {
          nameAddress: `${formData.bankName} ${formData.bankAddress}`,
          accNo: formData.accountNo,
          ifsc: formData.ifsc,
          operationalAt: "",
        },
      ],
      creditRatingId: formData.rating,
      creditRatingYear: formData.ratingYear,
      creditRatingAgency: formData.agency,
      isAcceptedByLaws: formData.byLaw,
      isAcceptedBusinessRule: formData.byRules,
    };

    handleData("bankRating", bankRating);
    handleProceed(data);
  };

  // Render Helpers
  const renderCheckbox = (label, field) => (
    <div
      className={Styles.checkSelction}
      onClick={() => handleChange(field, !formData[field])}
    >
      {formData[field] ? (
        <CheckBoxIcon style={{ fontSize: "24px", color: "#f1935c" }} />
      ) : (
        <CheckBoxOutlineBlankIcon
          style={{ fontSize: "24px", color: "#6f6d7c" }}
        />
      )}
      <div>
        <span>I Understand and Accept the</span>
        <span style={{ color: "#f1935c", paddingLeft: "8px" }}>{label}</span>
      </div>
    </div>
  );

  const renderTextInput = (
    field,
    heading,
    example,
    type = "text",
    readOnly = false
  ) => (
    <TextInput
      heading={`${heading} *`}
      value={formData[field]}
      onChange={(value) => handleChange(field, value)}
      example={example}
      type={type}
      height="45"
      error={errors[field]}
      readOnly={readOnly}
    />
  );

  const renderSelectInput = (field, heading, list, example) => (
    <SelectInput
      onChange={(value) => handleChange(field, value)}
      list={list}
      value={formData[field]}
      example={example}
      heading={`${heading} *`}
      height="45px"
      error={errors[field]}
    />
  );

  // Main Render
  return (
    <div className={Styles.elementMain}>
      <div className={Styles.displayInputSection}>
        <div className={Styles.conterntHeader}>Bank Details</div>
        <div className={Styles.layer1ElementsContainer}>
          {renderTextInput("bankName", "Bank Name", "Enter Bank Name")}
        </div>
        <div className={Styles.layer1ElementsContainer}>
          {renderTextInput(
            "bankAddress",
            "Branch Address",
            "Enter Branch Address"
          )}
        </div>
        <div className={Styles.layer2ElementsContainer}>
          {renderTextInput(
            "accountNo",
            "Account Number",
            "Enter Account Number"
          )}
          {renderTextInput("ifsc", "IFSC Code", "Enter IFSC Code")}
        </div>
        <div className={Styles.conterntHeader}>Rating</div>
        <div className={Styles.layer3ElementsContainer}>
          {renderSelectInput(
            "rating",
            "Credit Rating",
            publicData?.publicRating,
            "Eg. Select Credit Rating"
          )}
          {renderTextInput("ratingYear", "Credit Rating Year", "Eg. FEB 2025")}
          {renderTextInput("agency", "Credit Rating Agency", "Eg. GNA Energy")}
        </div>
        {renderCheckbox("Business Rules", "byRules")}
        {renderCheckbox("Bye Laws", "byLaw")}
      </div>
      <div className={Styles.buttonSection}>
        <div className={Styles.prevBtn} onClick={() => handleProceed("prev")}>
          Back
        </div>
        <div className={Styles.nextBtn} onClick={() => handleContinue("next")}>
          Next
        </div>
      </div>
    </div>
  );
};

export default BankDetails;
